import React from 'react';
import { Typography, FormControl, TextField, Skeleton, IconButton, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import get from 'lodash/get';
import find from "lodash/find";

const InputGroup = ({ children, formik, name, label, disabled, labelInput = null, fullWidth = true, loading, onClick, options = [], selectedId, ...props }) => {
   
    const selectedOption = find(options, ({ value }) => value === selectedId);
    const selectedLabel = selectedOption ? selectedOption.label : '';

    // console.log("Opciones:", options);
    // console.log("ID Seleccionado:", selectedId);

    return (
        <FormControl fullWidth={fullWidth}>
            {!labelInput && (
                <Typography
                    className="pb-2 pl-4"
                    component="label"
                    htmlFor={name}
                    color={disabled ? 'text.lite' : 'text.main'}
                >
                    {label}
                </Typography>
            )}
            {loading ? (
                <Skeleton className="mb-2" variant="rounded" width={fullWidth ? '100%' : '30%'} height={39} />
            ) : (
                <Box display="flex" alignItems="center">
                    <TextField
                        id={name}
                        name={name}
                        size="small"
                        value={selectedLabel}
                        onChange={get(formik, 'handleChange')}
                        error={get(formik, `touched.${name}`) && Boolean(get(formik, `errors.${name}`))}
                        helperText={get(formik, `touched.${name}`) && get(formik, `errors.${name}`)}
                        label={labelInput}
                        {...props}
                        sx={{ flexGrow: 1 }} 
                        disabled={disabled}
                    >
                        {children}
                    </TextField>
                    <IconButton
                        aria-label="search"
                        onClick={onClick} 
                        edge="end"
                        sx={{ ml: 1 }}
                    >
                        <SearchIcon />
                    </IconButton>
                </Box>
            )}
        </FormControl>
    );
};

export default InputGroup;
